<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('my.Platform_rules')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()" />
        </template>
      </van-nav-bar>
    </div>
    <div class="content">
      <div class="listTitle">{{ notice.title }}</div>
      <div class="heng"></div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="listItem">
          <div class="listContent html" v-html="notice.content"></div>
          <!-- <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div> -->
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice: {},
      loading: false,
      finished: false,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getNoticeList() {
      this.$http({
        method: "get",
        url: "platformRule",
      }).then((res) => {
        // console.log(res);
        this.notice = res.data;
        console.log("平台规则", this.notice);
      });
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
  },
  created() {
    this.getNoticeList();
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";
::v-deep .van-nav-bar__title{
  display: none !important;
}
::v-deep .van-nav-bar__content{
  background:rgba(255,255,255,0.1) !important;
}
.heng{
  width: auto;
  margin: 0 4rem;
  height: 4px;
  background-color: #fff;
  filter: drop-shadow(0 0 15px #fff);
  border-radius:1rem ;
}
.listTitle{
  color: #fff;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  font-size: 2rem;
  text-shadow: 0 0 30px #fff;
}
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .content {
  height: calc(100% - 20px);
  overflow: auto;
  background-image: url(../../assets/bc-img/gg.jpg);
  background-size: 100% 100%;
}
.container .content .listItem {
  margin-bottom: 20px;
  padding: 0px 20px 0;
  margin: @md1;
  position: relative;
  color: @white;
  // background-color: @theme1;
  // border: 1px solid #444;
  // border-radius: @br1;
}
.container .content .listItem .listTitle {
  font-size: 38px;
}
.container .content .listItem .listContent {
  // border-bottom: 2px solid @theme2;
  padding: 5px 0;
  font-size: 25px;
  font-weight: lighter !important;
  word-break: break-word;
}
.container .content .listItem .listContent /deep/ p {
  margin: 0 0 0.6rem;
}
.container .content .listItem .listTime {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 70px;
}
.container .content .listItem .listTime .listTimeText {
  color: #656566;
  font-size: 30px;
}
</style>
